module.exports = __webpack_public_path__ + "static/img/icon1.ea38e99.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon1.png
// module id = irsf
// module chunks = 42